import { Button as BaseButton } from "@mui/base";
import { ButtonProps } from "@mui/base/Button";
import { useButton } from "@mui/base/useButton";
import clsx from "clsx";
import React from "react";

import Spinner from "../spinner/Spinner";
import styles from "./Button.module.scss";

const Button = React.forwardRef(function CustomButton(
  props: ButtonProps & {
    fullWidth?: boolean;
    unstyled?: boolean;
    outlined?: boolean;
    danger?: boolean;
    noHover?: boolean;
    formId?: string;
    withSpinner?: boolean;
    className?: string;
  },
  ref: React.ForwardedRef<HTMLButtonElement>,
) {
  const {
    children,
    fullWidth,
    unstyled,
    outlined,
    danger,
    noHover,
    formId,
    withSpinner,
    className,
  } = props;
  const { active, getRootProps } = useButton({
    ...props,
    rootRef: ref,
  });

  return (
    <BaseButton
      rootElementName="button"
      {...getRootProps()}
      form={formId}
      className={clsx(styles.button, {
        [styles.button]: active,
        [styles.fullWidth]: fullWidth,
        [styles.unstyled]: unstyled,
        [styles.outlined]: outlined,
        [styles.danger]: danger,
        [styles.noHover]: noHover,
        [styles.loading]: withSpinner,
        [className || ""]: className,
      })}
    >
      {withSpinner && (
        <span
          className={clsx(styles.spinner, { [styles.visible]: withSpinner })}
        >
          <Spinner size="1rem" />
        </span>
      )}

      <span className={styles.label}>{children}</span>
    </BaseButton>
  );
});
export default Button;
